import { encodeRequestBody } from '~/utils/encodeRequestBody';

export function encodedJsonBody(value: unknown): string {
  return JSON.stringify(encodeRequestBody(value));
}
